import { g as d } from "../../utils-BOfnFgIH.js";
import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconNeutral",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function h(e, t, l, _, g, i) {
  return n(), o("svg", {
    "aria-label": l.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--neutral"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Neutral",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M6 1.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM.5 6a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM4 4.5a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H4.5a.5.5 0 0 1-.5-.5Zm3 0a.5.5 0 0 1 .5-.5h.005a.5.5 0 0 1 0 1H7.5a.5.5 0 0 1-.5-.5Zm-3.5 3A.5.5 0 0 1 4 7h4a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, m);
}
const S = /* @__PURE__ */ u(c, [["render", h]]);
export {
  S as default
};
//# sourceMappingURL=neutral.js.map
